import { QueryClient } from "@tanstack/react-query";

// Create a singleton query client for the widgets
let queryClient: QueryClient | null = null;

export function getQueryClient(): QueryClient {
  if (!queryClient) {
    queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 5 * 60 * 1000, // 5 minutes
          gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
          retry: 2,
          refetchOnWindowFocus: false,
        },
      },
    });
  }
  return queryClient;
}

